var orientationMatrix = [
	'C',
	'N',
	'NE',
	'E',
	'SE',
	'S',
	'SW',
	'W',
	'NW'
];

module.exports = {
	config: {
		type: '',
		focusAble: true,
		clickable: true,
		clickableOnly: false,
		autoOpen: false,
		orientation: 'N',
		// C, N, NE, E, SE, S, SW, W, NW
		// NOTE: NE stands for north-east and means that the popover-content will appear with its' south-west corner at the north-east corner of the popover-trigger.
		// NOTE: you may influence the opposite corner as well. you only need to add an extra orientation separated by minus. e.g., NE equals NE-SW
		// NOTE: there is an extra orientation called CORE (C) which means the geometric center of the elements. e.g., C equals C-C
		distance: {
			x: 0,
			y: 0
		}
	},

	model: {
		active: false,
		persistentActive: false
	},

	events: {
		show: {
			type: 'mouseenter',
			selector: '.popover_trigger',
			action: function(event){
				var self = event.data.component;
				if(!self.config.clickableOnly){
					self.show();
				}
			}
		},

		hide: {
			type: 'mouseleave',
			selector: '.popover_trigger',
			action: function(event){
				var self = event.data.component;
				if(!self.config.clickableOnly) {
					self.hide();
				}
			}
		},

		togglePersistent: {
			type: 'click',
			action: function(event){
				var self = event.data.component;
				if(self.config.clickable){
					event.stopImmediatePropagation();

					var $target = $(event.target).closest('.popover_trigger');
					if($target.length > 0){
						if(self.model.persistentActive){
							self.hide(true);
						}
						else {
							self.show(true);
						}
					}
				}
			}
		},

		hidePersistent: {
			type: 'focusout',
			selectorAddSelf: true,
			selector: '*',
			action: function(event){
				var self = event.data.component;
				if(event.relatedTarget === null || self.$.has($(event.relatedTarget)).length <= 0 && !self.$.is($(event.relatedTarget))){
					if(self.model.persistentActive){
						// prevent click-hide intended click-show after successful focus-out-hide in case
						// event.preventDefault();
						// event.stopImmediatePropagation();
						self.hide(true);
					}
				}
			}
		},

		// showPersistent: {
		// 	type: 'focusin',
		// 	selectorAddSelf: true,
		// 	selector: '*',
		// 	action: function(event){
		// 		var self = event.data.component;
		// 		// if(self.$.has($(event.relatedTarget)).length <= 0){
		// 		// 	if(self.model.persistentActive){
		// 		// 		// prevent click-hide intended click-show after successful focus-out-hide in case
		// 		// 		event.preventDefault();
		// 		// 		event.stopImmediatePropagation();
		// 		// 		self.hide(true);
		// 		// 	}
		// 		// }
		// 	}
		// }
	},

	methods: {
		show: function(persistent){
			if(persistent){
				this.model.persistentActive = true;
			}
			if(!this.model.active){
				this.model.active = true;
				this.$.addClass('active');
				this.onShow();
			}
			if(persistent){
				this.$.focus();
			}
		},

		hide: function(persistent){
			if(persistent || !this.model.persistentActive){
				this.model.persistentActive = false;
				if(this.model.active){
					this.model.active = false;
					this.$.removeClass('active');
					this.onHide();
				}
			}
		},

		toggle: function(persistent){
			if(this.model.active){
				this.hide(persistent);
			} else {
				this.show(persistent);
			}
		},

		onShow: function(){},
		onHide: function(){},

		refreshTrigger: function(){
			if(this.model.triggerComponent){
				// popovers state may be changed, so update trigger components data
				this.model.triggerComponent.resourceData = this.resourceData;
				this.model.triggerComponent.model = this.model;
				this.model.triggerComponent.config.type = this.config.type;
				this.model.triggerComponent.refresh(false);
			}
		},

		refreshDimensions: function(){
			var $trigger = this.$.find('.popover_trigger');
			var $content = this.$.find('.popover_content').css({
				width: 'auto',
				height: 'auto'
			});

			var triggerDimensions = {
				w: $trigger.outerWidth(),
				h: $trigger.outerHeight()
			};
			var contentDimensions = {
				w: $content.outerWidth(),
				h: $content.outerHeight()
			};

			var deltas = {
				trigger: {
					x: 0,
					y: 0
				},
				content: {
					x: 0,
					y: 0
				}
			};

			var orientation = String(this.config.orientation).split('-');
			orientation = {
				trigger: String(orientation[0]).toUpperCase(),
				content: String(orientation[1] || '').toUpperCase()
			};

			if(orientation.content === ''){
				if(orientation.trigger === 'C') {
					orientation.content = 'C';
				} else if((orientationMatrix.indexOf(orientation.trigger) + 4) > 8){
					orientation.content = orientationMatrix[(orientationMatrix.indexOf(orientation.trigger) - 4)];
				} else {
					orientation.content = orientationMatrix[(orientationMatrix.indexOf(orientation.trigger) + 4)];
				}
			}

			// trigger x
			if(orientation.trigger.indexOf('W') > -1) {
				deltas.trigger.x = 0;
			} else if(orientation.trigger.indexOf('E') > -1){
				deltas.trigger.x = 1;
			} else {
				deltas.trigger.x = 0.5;
			}

			// trigger y
			if(orientation.trigger.indexOf('N') > -1) {
				deltas.trigger.y = -1;
			} else if(orientation.trigger.indexOf('S') > -1){
				deltas.trigger.y = 0;
			} else {
				deltas.trigger.y = -0.5;
			}

			// content x
			if(orientation.content.indexOf('W') > -1){
				deltas.content.x = 0;
			} else if(orientation.content.indexOf('E') > -1){
				deltas.content.x = -1;
			} else {
				deltas.content.x = -0.5;
			}

			// content y
			if(orientation.content.indexOf('N') > -1){
				deltas.content.y = 0;
			} else if(orientation.content.indexOf('S') > -1){
				deltas.content.y = -1;
			} else {
				deltas.content.y = -0.5;
			}

			var triggerLeft = (deltas.trigger.x * triggerDimensions.w) + 'px';
			var triggerTop = (deltas.trigger.y * triggerDimensions.h) + 'px';
			if(this.config.distance.x){
				if(deltas.trigger.x === 0 && deltas.content.x === -1){
					triggerLeft = 'calc(' + triggerLeft + ' - ' + this.config.distance.x + ')';
				} else if(deltas.trigger.x === 1 && deltas.content.x === 0){
					triggerLeft = 'calc(' + triggerLeft + ' + ' + this.config.distance.x + ')';
				}
			}
			if(this.config.distance.y){
				if(deltas.trigger.y === 0 && deltas.content.y === 0){
					triggerTop = 'calc(' + triggerTop + ' + ' + this.config.distance.y + ')';
				} else if(deltas.trigger.y === -1 && deltas.content.y === -1){
					triggerTop = 'calc(' + triggerTop + ' - ' + this.config.distance.y + ')';
				}
			}

			// prevent blurry problems when using translate3d
			var width = parseInt(contentDimensions.w);
			var height = parseInt(contentDimensions.h);
			if(width < contentDimensions.w) 	width++;
			if(height < contentDimensions.h) 	height++;
			if((width % 2) > 0) 	width++;
			// needed because of flooring-"feature" of $.getOuterWidth()
			else 					width += 2;
			if((height % 2) > 0) 	height++;
			// needed because of flooring-"feature" of $.getOuterHeight()
			else 					height += 2;

			$content.css({
				'margin-left': triggerLeft,
				'margin-top': triggerTop,
				'transform': 'translate3d(' + (deltas.content.x * 100) + '%, ' + (deltas.content.y * 100) + '%, 0)',
				'min-width': width,
				'min-height': height
			});
		}
	},

	hooks: {
		attach: function($element, options){
			var self = this;
			
			this.refreshDimensions();

			if(!options.refresh && this.config.autoOpen){
				this.show(this.config.clickableOnly);
			}
			else if (this.model.active){
				this.$.focus();
			}

			if(!this.model.triggerComponent){
				var $potentialTriggerComponent;
				if(($potentialTriggerComponent = this.$.find('> .popover_trigger > [data-component-index]')).length > 0){
					self.model.triggerComponent = getComponent($potentialTriggerComponent);
				}
			}
		}
	}
};
